module.exports = __webpack_public_path__ + "static/media/allstar-tickets.5594f148.png";